import React from 'react';
import Modal from 'components/Modal';
import { useSocialShareModal } from '../SocialShareModalContext';
import useIsBlockingActionInProgress from '../useIsBlockingActionInProgress';
import { socialShareModalFooterBlock as block } from '../utils';

export type ShareButtonProps = {
  isDisabled?: boolean;
  onShare?: () => void;
};

const ShareButton: React.FC<ShareButtonProps> = ({ isDisabled, onShare }) => {
  const { isSchedulingPost, scheduledDate } = useSocialShareModal();
  const isBlockingActionInProgress = useIsBlockingActionInProgress();

  return (
    <Modal.FooterButton
      theme="submit"
      fluid={isBlockingActionInProgress}
      disabled={isDisabled || isBlockingActionInProgress}
      className={block('submit-button', {
        small: !!scheduledDate && !isSchedulingPost,
      })}
      onClick={onShare}
    >
      {isBlockingActionInProgress
        ? ''
        : scheduledDate
        ? 'Schedule'
        : 'Publish Now'}
    </Modal.FooterButton>
  );
};

export default ShareButton;
